import React from "react";

const SettingsContext = React.createContext({
  unsavedTeamName: null,
  unsavedRates: null,
});

export default SettingsContext;
